import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from "vuetify/es5/locale/es";

Vue.use(Vuetify);

const colores = {
    blue: "#3688fc",
    red: "#fa6767",
    yellow: "#f9bc0d",
    green: "#42d29d",
    primary: "#3688fc",
    secondary: "#919ca7",
    success: "#42d29d",
    info: "#44badc",
    warning: "#f9bc0d",
    danger: "#fa6767",
    light: "#eef2f7",
    dark: "#313a46",
    indigo: "#727cf5",
    purple: "#6b5eae",
    pink: "#ff679b",
    orange: "#ff9041",
    teal: "#02a8b5",
    cyan: "#44badc",
    violet: "#c417db",
    wheat: "#f5deb3",
    "gradient-1":"#4354e2",   
    "gradient-2":"#dc4985",   
    "gradient-3":"#2cc590",   
    "gradient-4":"#a866d1",
};

export default new Vuetify({
    theme: {
        themes: {
            light: colores
        }
    },
    lang: {
        locales: { es },
        current: "es"
    }
});
